<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
    :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
    :selection="{ mode: 'single' }"
    :show-borders='true'
    :style="{ height: localHeight, width: localWidth }"
    :columns="reportData.IsSummary ? fieldsSummary : fields"
    :summary="summary"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @content-ready="onContentReady"
    @cell-click="onSelectionChanged")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';
import { SETTINGS_EVENTS } from '~/consts/eventTypes';

export default {
  name: 'EngineHours',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
    track: {
      type: Object,
      default () {
        return {};
      },
    },
    colors: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'Begin',
        caption: 'Начало',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 150,
      }, {
        dataField: 'End',
        caption: 'Окончание',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 150,
      }, {
        dataField: 'BeginLocation',
        caption: 'Начальное положение',
      }, {
        dataField: 'EndLocation',
        caption: 'Конечное положение',
      }, {
        dataField: 'EngineHoursText',
        caption: 'Моточасы',
        alignment: 'center',
        width: 110,
      }, {
        dataField: 'EngineHoursInParkingsText',
        caption: 'Моточасы в стоянках',
        alignment: 'center',
        width: 110,
      }, {
        dataField: 'EngineHoursInRidesText',
        caption: 'Моточасы в поездках',
        alignment: 'center',
        width: 110,
      }],
      fieldsSummary: [{
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'ObjectName',
        caption: 'Объект',
      }, {
        dataField: 'SumEngineHoursText',
        caption: 'Моточасы',
        alignment: 'center',
      }, {
        dataField: 'SumEngineHoursInParkingsText',
        caption: 'Моточасы в стоянках',
        alignment: 'center',
      }, {
        dataField: 'SumEngineHoursInRidesText',
        caption: 'Моточасы в поездках',
        alignment: 'center',
      }],
      summaryColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'EngineHoursText',
        name: 'EngineHoursText',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'SumEngineHoursText',
        name: 'EngineHoursText',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'EngineHoursInParkingsText',
        name: 'EngineHoursInParkingsText',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'SumEngineHoursInParkingsText',
        name: 'EngineHoursInParkingsText',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'EngineHoursInRidesText',
        name: 'EngineHoursInRidesText',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'SumEngineHoursInRidesText',
        name: 'EngineHoursInRidesText',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      summary: null,
      rowClick: null,
      reportSummary: [],
    };
  },
  watch: {
    reportData (value) {
      this.rowClick = null;
      if (this.reportData.IsSummary) {
        this.convertSummaryData(this.reportData);
      }
      this.getSummary();
      this.getAddresses();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    }
    this.getSummary();
    this.getAddresses();
    this.$eventBus.subscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
      this.getAddresses,
    );
  },
  beforeDestroy () {
    this.$eventBus.unsubscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
    );
  },
  methods: {
    onSelectionChanged (item) {
      if (item.rowType === 'data') {
        if (this.reportData.BuildTrack && this.track.Id) {
          if (!(this.rowClick && this.rowClick.Begin === item.data.Begin && this.rowClick.End === item.data.End)) {
            const timeZone = Number(this.reportData.TimeZone.split(':', 3)[0]);
            const periods = [[new Date((item.data.Begin - timeZone * 3600) * 1000), new Date((item.data.End - timeZone * 3600) * 1000)]];
            this.$store.dispatch('tracks/updateTrack', { reportId: this.track.Id, secondColor: this.colors.alternative.hex, periods });
            this.reportData.periodsPartTrack = periods;
            this.rowClick = {
              Begin: item.data.Begin,
              End: item.data.End,
            };
          }
        }
        if (item.column.dataField === 'Begin' || item.column.dataField === 'BeginLocation') {
          const value = {
            lat: item.data.BeginLocationLatitude,
            lng: item.data.BeginLocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
        if (item.column.dataField === 'End' || item.column.dataField === 'EndLocation') {
          const value = {
            lat: item.data.EndLocationLatitude,
            lng: item.data.EndLocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
      }
    },

    convertSummaryData (data) {
      this.reportSummary = data.Data.Data.map((x, i) => ({ ...x, RowNum: i + 1 }));
    },

    getSummary () {
      if (!this.reportData.IsSummary) {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              const totalValue = this.reportData.Data.Data[`Sum${options.name}`];
              if (totalValue !== undefined) {
                value.totalValue = totalValue;
              }
            }
          },
          totalItems: this.summaryColoumn,
        };
      } else {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              if (options.groupIndex === undefined) {
                const totalValue = this.reportData.Data[`Sum${options.name}`];
                if (totalValue !== undefined) {
                  value.totalValue = totalValue;
                }
              }
            }
          },
          totalItems: this.summaryColoumn,
        };
      }
    },

    getAddresses () {
      if (this.reportData.State === 'Done' || this.reportData.State === 'OK') {
        if (!this.reportData.IsSummary) {
          this.reportData.Data.Data.Rows.forEach((row) => {
            this.getAddress(row.BeginLocationLatitude, row.BeginLocationLongitude, row, true);
            this.getAddress(row.EndLocationLatitude, row.EndLocationLongitude, row, false);
          });
        }
      }
    },
    getAddress (lat, lon, _row, begin) {
      const row = _row;
      const location = begin ? 'BeginLocation' : 'EndLocation';
      row[location] = null;
      setImmediate(async () => {
        const address = await this.$store.dispatch('nominatim/getAddress', { lat, lon });
        row[location] = address;
      });
    },
  },
};
</script>
